import { createSlice } from "utils/@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import set from "lodash/set";
import { FormError } from "app/containers/types";
import { ContainerState } from "../types";

// The initial state of the GithubRepoForm container
export const initialState: ContainerState = {
  password: {
    value: "",
  },
  confirmPassword: {
    value: "",
  },
  loading: false,
  error: null,
};

const formSlice = createSlice({
  name: "resetPasswordState",
  initialState,
  reducers: {
    setFormValues: (state, action: PayloadAction<{ key: string; value: string }>) => {
      const { key, value } = action.payload;
      set(state, `${key}.value`, value);
      set(state, `${key}.error`, "");
    },
    setFormErrors(
      state,
      action: PayloadAction<Array<FormError>>
    ) {
      action.payload.forEach((error) => {
        set(state, `${error.name}.error`, error.error);
      });
    },
    submit(state, action: PayloadAction<{ callback: () => void; creds: { password: string; hash: string; email: string } }>) {
      state.loading = true;
      state.error = null;
    },
    submitSuccess(state) {
      state.password = {
        value: "",
      };
      state.confirmPassword = {
        value: "",
      };
      state.loading = false;
      state.error = null;
    },
    submitError(state) {
      state.loading = false;
    }
  },
});

export const { actions, reducer: resetPasswordReducer, name: resetPasswordSlice } = formSlice;
